import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/login.css';
import logo from '../assets/images/Group_365.png';
import buttonImg from '../assets/images/Button.png';
import dropdownImg from '../assets/images/Drop down.png';

const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://web-mentoring-production.up.railway.app'
    : 'http://localhost:8080';

const Login = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [password, setPassword] = useState('');
  const [spartanList, setSpartanList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchSpartanData = async () => {
      try {
        setLoading(true);
        setError('');

        const response = await fetch(`${API_BASE_URL}/api/spartan`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Server error: ${response.status}`);
        }

        const data = await response.json();
        console.log('API Response:', data);

        if (data.status === 'success' && Array.isArray(data.data)) {
          setSpartanList(data.data);
          console.log('Spartan list loaded:', data.data);
        } else {
          throw new Error('Invalid data format from server');
        }
      } catch (err) {
        console.error('Error fetching spartan data:', err);
        setError('Gagal memuat data dari server. Periksa koneksi backend.');
      } finally {
        setLoading(false);
      }
    };

    fetchSpartanData();
  }, []);

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
    setError(''); // Clear error when user selects different option
    console.log('Selected option:', e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setError(''); // Clear error when user types password
  };

  const handleLogin = async () => {
    if (!selectedOption) {
      setError('Pilih nama Spartan terlebih dahulu');
      return;
    }

    if (!password) {
      setError('Masukkan password');
      return;
    }

    try {
      setLoginLoading(true);
      setError('');

      // PERBAIKAN: Gunakan nim sebagai key, sesuai dengan database
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nim: parseInt(selectedOption),
          password: password,
        }),
      });

      const data = await response.json();
      console.log('Login response:', data); // Debug log

      if (response.ok && data.status === 'success') {
        // Login berhasil
        localStorage.setItem('selectedSpartan', JSON.stringify(data.data));
        console.log('Login successful for:', data.data.nama);
        navigate('/homepage');
      } else {
        // Login gagal
        setError(data.error || 'Login gagal. Periksa password Anda.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Terjadi kesalahan saat login. Periksa koneksi backend.');
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="Logo" className="logo" />

      <div className="dropdown-container">
        <select
          value={selectedOption}
          onChange={handleChange}
          className="custom-dropdown"
          disabled={loading}
        >
          <option value="" disabled>
            {loading ? 'Memuat data...' : 'Pilih Nama Spartan'}
          </option>

          {spartanList.length > 0 ? (
            spartanList.map((spartan) => (
              <option key={spartan.nim} value={spartan.nim}>
                {spartan.nama}
              </option>
            ))
          ) : (
            !loading && (
              <option value="" disabled>
                Tidak ada data tersedia
              </option>
            )
          )}
        </select>
        <img src={dropdownImg} alt="Dropdown arrow" className="dropdown-arrow" />
      </div>

      {/* Input Password */}
      <div className="password-container">
        <input
          type="password"
          value={password}
          onChange={handlePasswordChange}
          placeholder="Masukkan Password"
          className="password-input"
          disabled={loading || loginLoading}
        />
      </div>

      <button
        className="login-button"
        onClick={handleLogin}
        disabled={loading || !selectedOption || !password || loginLoading}
      >
        <img src={buttonImg} alt="Login button" className="button-img" />
        <span className="button-text">
          {loginLoading ? 'Logging in...' : loading ? 'Loading...' : 'Login'}
        </span>
      </button>

      {error && (
        <div className="error-message">
          <p>⚠️ {error}</p>
          {error.includes('backend') && (
            <p style={{ fontSize: '12px', marginTop: '5px' }}>
              Pastikan backend berjalan
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Login;